pageId = 'shimo-documents-new'
page = '#' + pageId

$ ->
  $importLink = $("#{page} #link-shimo-import")

  $importLink.on 'click', ->
    $dialog = $ simple.tpl $('#tpl-shimo-import-dialog').html()
    $files = $dialog.find('.files')
    $submit = $dialog.find('button[type=submit]')

    tree = simple.tree
      el: $files
      url: '/shimo/files'
      placeholder: '无文件'
      nodeProperties:
        id: 'guid'
        params:
          folder: 'guid'
      onNodeRender: ($node, item) ->
        if item.type == 'folder'
          $node.find('.toggle').after('<i class="icon-folder twr twr-folder"/>');
        else
          $node.addClass("icon-shimo icon-#{item.type}")

    dialog = simple.dialog
      content: $dialog
      width: 450
      modal: true
      buttons: null

    $dialog.find('.btn-cancel-import').on 'click', ->
      dialog.remove()

    tree.on 'nodeselected', (e, $node, item) ->
      $dialog.find('.shimo_documents_import_shimo_id').val(item.guid)
      $dialog.find('.shimo_documents_import_title').val(item.name)
      $dialog.find('.shimo_documents_import_category').val(item.type)
      $submit.prop 'disabled', false

    $dialog.find('form').on 'ajax:success', (e, result) ->
      return unless result.msg
      simple.dialog.message
        content: result.msg
